<template>
  <div class="contais">
    <!-- 顶部内容 -->
    <div class="content_header">
      <div class="query">
        <Query @child-event="emitToparent" message="房产"></Query>
      </div>
      <div class="infos">
        <div class="infos_num">
          <h2>今日新增：{{ TodayData }}</h2>
          <h3>金额：{{ TodaySumPrice }}</h3>
        </div>
        <div class="infos_num">
          <h2>在当业务：{{ TotalData }}</h2>
          <h3>金额：{{ Sumprice }}</h3>
        </div>
      </div>
    </div>

    <!-- 业务列表 -->
    <div class="content">
      <!-- 筛选栏 -->
      <div class="content_a">
        <span class="zd">正常存当业务</span>
        <span class="jr">今日到期业务</span>
        <span class="xz">今日新增业务</span>
        <span class="cq">超期业务</span>
      </div>
      <!-- 业务列表 -->
      <div class="table">
        <el-table
          border
          :data="tableData"
          :row-class-name="tableRowClassName"
          style="width: 100%"
        >
          <el-table-column prop="CreateDate" label="建当日期"> </el-table-column>
          <el-table-column prop="Piaonumber" label="票号"> </el-table-column>
          <el-table-column prop="Dhname" label="当户姓名"> </el-table-column>
          <el-table-column prop="Ddedquota" label="典当额度"> </el-table-column>
          <el-table-column prop="DdqxStartDate" label="典当开始日期" width="180">
          </el-table-column>
          <el-table-column prop="DdqxEndDate" label="典当到期日期" width="180">
          </el-table-column>
          <el-table-column prop="ZhfPrice" label="典当综合/费率"> </el-table-column>
          <el-table-column prop="lx" label="典当利息/费率"> </el-table-column>
          <el-table-column prop="Fcaddres" label="房产地址"> </el-table-column>
          <el-table-column prop="DyfsGuaranty" label="抵押方式"> </el-table-column>
          <el-table-column prop="CreateUser" label="经办人"> </el-table-column>
          <el-table-column prop="Review" label="复核"> </el-table-column>
          <el-table-column prop="Finance" label="财务"> </el-table-column>

          <el-table-column fixed="left" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="ToWatch(scope.row)"
                >查看</el-button
              >
              <el-button type="text" size="small" @click="ContinueD(scope.row)"
                >续当</el-button
              >
              <el-button type="text" size="small" @click="RansomClick(scope.row)"
                >赎当</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 弹窗 -->
      <el-dialog
        title="续当"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose"
      >
        <div class="Xdetail">
          <span>典当状态：{{ state }}</span>
          <span>票号：{{ DetailData.Piaonumber }}</span>
          <span>当户：{{ DetailData.Dhname }}</span>
          <span>典当额度：{{ DetailData.Ddedquota }}</span>
          <span>到期日期：{{ DetailData.DdqxEndDate }}</span>
          <span>登记证：{{ DetailData.TxqzWarrant }}</span>
          <span>续当天数：{{ Xnum }}天</span>
          <span>
            选择当期：
            <!-- <el-button-group>
                    <el-button type="primary" @click="Thirty(30)">30天</el-button>
                    <el-button type="primary" @click="Thirty(60)">60天</el-button>
                 </el-button-group> -->
            <el-date-picker
              v-model="NewDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @change="DateChange"
            >
            </el-date-picker>
          </span>
          <span>续当到期日期：{{ NewDate }}</span>
          <span
            >典当综合费：
            <input type="number" v-model="Zprice" />
          </span>
          <span
            >典当利息：
            <input type="number" v-model="lx" />
          </span>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Query from "@/components/Query.vue";
import dayjs from "dayjs";
export default {
  name: "whenhouse",

  components: {
    Query,
  },
  data() {
    return {
      TodayData: 0, // 今天的新增的业务数量
      TotalData: 0, //总业务数量
      Date: "", //今日的日期
      Sumprice: 0, //总金额
      TodaySumPrice: 0, //今日的总金额

      tableData: [], //在当数据
      day: "", //绝当日期

      dialogVisible: false, //弹窗开关
      DetailData: {}, //弹窗数据
      Xnum: 0, //选择的续当天数
      NewDate: "", //新到期日期

      Zprice: 0, //综合费
      lx: 0, //利息

      UserName: "", //当前登录的账户名
      state: "", //典当状态

      yday: 0, //逾期天数
    };
  },
  methods: {
    //计算续当天数
    DateChange() {
      this.Xnum = dayjs(this.NewDate).diff(dayjs(this.DetailData.DdqxEndDate), "day");
      if (this.state == "正常业务") {
        //正常业务

        //综合费
        this.Zprice = Math.trunc(
          ((Number(this.DetailData.Ddedquota) * 0.02) / 30) *
            dayjs(this.NewDate).diff(dayjs(this.DetailData.DdqxEndDate), "day")
        );
        //利息
        this.lx = 0;
      } else {
        //业务业务

        //逾期综合费
        this.Zprice = Math.trunc(
          ((Number(this.DetailData.Ddedquota) * 0.027) / 30) *
            dayjs(this.NewDate).diff(dayjs(this.DetailData.DdqxEndDate), "day")
        );
        //逾期利息
        this.lx = Math.trunc(
          ((Number(this.DetailData.Ddedquota) * 0.003) / 30) *
            dayjs(this.NewDate).diff(dayjs(this.DetailData.DdqxEndDate), "day")
        );
      }
    },
    //默认所有数据请求数据
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("house").where({Review:_.neq(""),State:"在当",DdqxEndDate:_.gte("${this.day}")}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          this.TotalData = res.data.pager.Total;
          this.Sumprice = this.SumPrice(res.data.data);
          this.tableData = res.data.data;
        });
    },
    //默认请求今天的数据
    getTodayData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("house").where({ReviewDate:"${this.Date}"}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          this.TodayData = res.data.pager.Total;

          this.TodaySumPrice = this.SumPrice(res.data.data);
        });
    },
    //计算总金额
    SumPrice(event) {
      //循环计算新增典当的总金额
      let str = "";
      for (let i in event) {
        str += event[i].Ddedquota;
        str += "+";
      }
      str = str.substring(0, str.length - 1);
      // this.Sumprice = eval(str) || 0;
      return eval(str) || 0;
    },

    //接收子组件的查找数据
    emitToparent(event) {
      if (event.length == 0) {
        return this.$alert("未查询到该业务", "查询结果", {
          confirmButtonText: "确定",
        });
      }

      this.tableData = event.filter((item) => {
        return item.Review !== "";
      });
    },
    //业务颜色筛选
    tableRowClassName({ row }) {
      if (row.DdqxEndDate > this.day && row.DdqxEndDate < this.Date) {
        return "success-row";
      }
      //今天绝当最后一天
      if (row.DdqxEndDate == this.day) {
        return "warning-row";
      }
      //今日新增业务
      if (row.ReviewDate == this.Date) {
        return "today-row";
      }
      //今日到期业务
      if (row.DdqxEndDate == this.Date) {
        return "tod-row";
      }

      return "";
    },

    //查看
    ToWatch(event) {
      this.$router.push({
        path: "/House/houseDetail",
        query: { str: this.$Base64.encode(JSON.stringify(event)), state: 3 },
      });
    },
    //续当
    ContinueD(event) {
      this.DetailData = event;
      this.dialogVisible = !this.dialogVisible;
      if (event.DdqxEndDate > this.Date) {
        //正常业务
        this.state = "正常业务";
      } else {
        //逾期
        this.state = "逾期业务";
        //逾期天数
        this.yday = dayjs().diff(event.DdqxEndDate, "day");
      }
    },
    //关闭续当弹窗
    handleClose() {
      (this.DetailData = {}),
        (this.Xnum = 0),
        (this.NewDate = ""),
        (this.yday = 0),
        (this.Zprice = 0),
        (this.lx = 0),
        (this.state = ""),
        (this.dialogVisible = false);
    },

    //当期
    Thirty(event) {
      this.Xnum = event;
      this.NewDate = dayjs(this.DetailData.DdqxEndDate)
        .add(event, "day")
        .format("YYYY-MM-DD");
    },
    //确定按钮
    confirm() {
      if (this.NewDate !== "") {
        this.$confirm("确定要续当吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.SetDetailData(this.NewDate, this.DetailData._id);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消续当",
            });
          });
      } else {
        this.$message.error("请选择续当期限");
      }
    },
    //确定续当事件
    SetDetailData(date, id) {
      let sum_pri = Number(this.Zprice) + Number(this.lx);
      //修改到期日期

      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("house").doc("${id}").update({data:{DdqxEndDate:"${date}"}})`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.addData("续当", sum_pri);
          } else {
            this.$notify({
              title: "续当失败",
              message: res.data.errmsg,
              type: "warning",
            });
          }
        });
    },
    //赎当点击事件
    RansomClick(event) {
      this.DetailData = event;
      this.$confirm("确定要赎当吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.Ransom(event);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消续当",
          });
        });
    },
    //赎当操作
    Ransom(event) {
      //赎当执行
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("house").doc("${event._id}").update({data:{State:"赎当"}})`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.addData("赎当", event.Ddedquota);
          } else {
            this.$notify({
              title: "续当失败",
              message: res.data.esrrmg,
              type: "warning",
            });
          }
        });
    },

    //添加流水
    addData(state, sumPri) {
      //第一个参数是状态，第二个参数总应收和实收
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").add({data:{name:"${
            this.DetailData.Dhname
          }",xuday:"${this.Date}",cardnumber:"${
            this.DetailData.Cardnumber
          }",itemname:"房产-${this.DetailData.TxqzWarrant}",
            ticketnumber:"${this.DetailData.Piaonumber}",telnumber:"${
            this.DetailData.tel
          }",startdate:"${this.DetailData.DdqxStartDate}",xupri:"${this.Zprice}",
            enddate:"${this.NewDate}",dday:"${this.Xnum}",xuname:"${
            this.UserName
          }",overdate:"${dayjs(this.DetailData.DdqxEndDate)
            .add(1, "day")
            .format("YYYY-MM-DD")}",ytdy:"${
            this.yday
          }",pena:"0",rece:"${sumPri}",yspri:"${sumPri}",stas:"${state}",pri:"${
            this.DetailData.Ddedquota
          }",lx:"${this.lx}",couqons:"线下不适用",couqonmoney:"0",xnumber:""}})`,
        })
        .then(() => {
          this.$notify({
            title: `${state}成功`,
            message: `当户 ${this.DetailData.Dhname} 典当业务${state}完成`,
            type: "success",
          });

          setTimeout(() => {
            this.$router.go(0);
          }, 1000);
        });
    },
  },
  created() {
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();

    //今天的日期
    this.Date = dayjs().format("YYYY-MM-DD");

    //逾期、绝当鉴定日期
    this.day = dayjs().subtract(5, "day").format("YYYY-MM-DD");
    // this.day =

    //拿到每月1号的日期
    // let testDate = dayjs().month() + 1;

    // let a = dayjs()

    // let testDate = dayjs().set("month", 10).format("YYYY-MM-DD");

    // console.log(testDate);
  },
  mounted() {
    setTimeout(() => {
      this.getData();
      this.getTodayData();
      this.UserName = this.userData.username;
    }, 800);
  },
};
</script>
<style scoped>
.content_header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.query {
  width: 58%;
  background: #ffffff;
}
.infos {
  width: 40%;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.infos_num {
  width: 40%;
  height: 60%;
  background: #218f4b;
  border-radius: 10px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.infos_num h2 {
  margin: 0 0;
}
.infos_num h3 {
  margin: 0 0;
}
.content {
  margin: 1% auto;
  width: 100%;
  background-color: #ffffff;
}
.content_a {
  /* width: 100%; */
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 10px 0;
}
.zd {
  width: 100px;
  height: 100%;
  border: 3px solid #000000;
}
.jr {
  width: 100px;
  height: 100%;
  border: 3px solid #4973a3;
}
.xz {
  width: 100px;
  height: 100%;
  border: 3px solid #4bb994;
}
.cq {
  /* width: 100px; */
  height: 100%;
  border: 3px solid #b9bb3d;
}
.cq5 {
  width: 100px;
  height: 100%;
  border: 3px solid #b9424c;
}

/*今日新增样式*/
.el-table >>> .today-row {
  background: #4bb994;
}
/* 快绝当样式 */
.el-table >>> .warning-row {
  background: #fa9393;
}
/* 逾期样式 */
.el-table >>> .success-row {
  background: #ccc22d;
}
/* 今天到期的业务 */
.el-table >>> .tod-row {
  background: #a2b6d4;
}
.Xdetail {
  display: flex;
  flex-direction: column;
}
.Xdetail span {
  margin: 10px 0;
}
</style>
